import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '@/core/models/enum'
import { getSensorDownlinkCapability } from '@/api/apiService'
import { Sensor } from '../models'

export function useSensorDownlinkCapability(sensor: Sensor | null) {
    const sensorDbKey = sensor?.sensorDbKey ?? ''
    return useQuery({
        queryKey: [QueryKeys.DownlinkCapability, sensorDbKey],
        enabled: !!sensorDbKey,
        queryFn: () => getSensorDownlinkCapability(sensorDbKey),
    })
}
